"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStore = void 0;
var mobx_1 = require("mobx");
var LoadableStore_1 = require("./LoadableStore");
var FormStore = /** @class */ (function (_super) {
    __extends(FormStore, _super);
    function FormStore() {
        var _this = _super.call(this) || this;
        Object.defineProperty(_this, "formStarted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "validationErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        mobx_1.makeObservable(_this, {
            formStarted: mobx_1.observable,
            error: mobx_1.observable,
            result: mobx_1.observable,
            validationErrors: mobx_1.observable,
            reset: mobx_1.action,
            startForm: mobx_1.action,
            setValidationErrors: mobx_1.action,
        });
        return _this;
    }
    Object.defineProperty(FormStore.prototype, "isLoading", {
        // Convenience getters
        get: function () {
            return this.loadingTimer.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormStore.prototype, "destroyHelper", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            // @ts-ignore TS doesn't like getting the constructor directly from this
            this.constructor.destroy();
        }
    });
    Object.defineProperty(FormStore.prototype, "stillLoading", {
        get: function () {
            return this.loadingTimer.stillLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormStore.prototype, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.loadingTimer.finishLoading();
            this.formStarted = false;
            this.error = undefined;
            this.result = undefined;
        }
    });
    Object.defineProperty(FormStore.prototype, "startForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.formStarted = true;
        }
    });
    Object.defineProperty(FormStore.prototype, "setValidationErrors", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (errors) {
            this.validationErrors = errors;
        }
    });
    return FormStore;
}(LoadableStore_1.LoadableStore));
exports.FormStore = FormStore;
//# sourceMappingURL=FormStore.js.map